// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1G4s_","actionsCol":"EnrolledClinics_actionsCol__DIuF-"};